export default "__VITE_ASSET__DA4LghkE__";